import { PostApiV1ThreeLetterCodeClientAdminsClientNewslettersBody } from '@fukuri-admins/apis/client/gen/model';
import { fileToUrlByBase64 } from '@fukuri-admins/utils/common/fileToUrlByBase64';
import { PUBLISH_TYPE } from '../../constants';
import type { CreateInternalNewsFormValues } from '../schema';

const resolvePublishAt = (data: CreateInternalNewsFormValues): string => {
  if (data.publishMode === PUBLISH_TYPE.IMMEDIATELY) {
    return new Date().toISOString();
  }
  if (data.scheduledDate && data.scheduledTime) {
    const [hours, minutes] = data.scheduledTime.split(':').map(Number);
    const scheduledAt = new Date(data.scheduledDate);
    scheduledAt.setHours(hours, minutes, 0, 0);
    return scheduledAt.toISOString();
  }
  return new Date().toISOString();
};

/**
 * フォーム値から社内報作成 API のリクエスト JSON ボディを生成する。
 * main_image は fileToUrlByBase64 で Base64 Data URI に変換して送信する。
 * file_signed_ids は事前アップロードで取得した signed_id の配列を送信する。
 */
type IGenerateRequestBody = (
  data: CreateInternalNewsFormValues
) => Promise<PostApiV1ThreeLetterCodeClientAdminsClientNewslettersBody>;

export const generateRequestBody: IGenerateRequestBody = async data => {
  const publishAt = resolvePublishAt(data);

  const mainImage = data.mainImage != null ? await fileToUrlByBase64(data.mainImage) : undefined;

  return {
    client_newsletter: {
      title: data.title,
      body: data.body,
      publish_at: publishAt,
      main_image: mainImage,
      file_signed_ids: data.fileSignedIds,
    },
  };
};
